import { FC } from "react"
import clsx from "clsx"

/** Google truncates on pixel width, not characters; these approximate its desktop/mobile cut-offs. */
const DESKTOP_TITLE_CHARS = 60
const DESKTOP_DESCRIPTION_CHARS = 160
const MOBILE_TITLE_CHARS = 50
const MOBILE_DESCRIPTION_CHARS = 120

const truncate = (value: string, limit: number): string => (value.length > limit ? `${value.slice(0, limit - 1).trimEnd()}…` : value)

interface SerpPreviewProps {
  host: string
  path: string
  title: string
  description: string
  device: "desktop" | "mobile"
}

export const SerpPreview: FC<SerpPreviewProps> = ({ host, path, title, description, device }) => {
  const isMobile = device === "mobile"
  const crumbs = path.split("/").filter(Boolean)

  return (
    <div
      className={clsx("rounded-xl bg-white px-4 py-4 font-[Arial,sans-serif] text-[#202124]", isMobile ? "max-w-[360px]" : "max-w-[600px]")}
    >
      <div className="text-[12.5px] text-[#4d5156]">
        {host ? <b className="font-normal text-[#202124]">{host}</b> : null}
        {crumbs.length > 0 && `${host ? " › " : "/"}${crumbs.join(" › ")}`}
      </div>
      <div className={clsx("my-1 leading-snug text-[#1a0dab]", isMobile ? "text-[17px]" : "text-[19px]")}>
        {truncate(title, isMobile ? MOBILE_TITLE_CHARS : DESKTOP_TITLE_CHARS) || "Untitled page"}
      </div>
      <div className="text-[13px] leading-relaxed text-[#4d5156]">
        {truncate(description, isMobile ? MOBILE_DESCRIPTION_CHARS : DESKTOP_DESCRIPTION_CHARS) || "No meta description set."}
      </div>
    </div>
  )
}
